import src from "IMAGE";
export default { src, width: 1920, height: 512, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAALklEQVR42n2KwQkAMAjEHK/99t0hCgWXF4mcA/gIHJeYL/AN/yTvRqOtT846GCiX9yvh9j3D9AAAAABJRU5ErkJggg=="};
